import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionRevokedService } from '../../../services/session-revoked.service';
import { ModalComponent } from '../../ui/modal/modal.component';

@Component({
  selector: 'app-session-revoked-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './session-revoked-modal.component.html'
})
export class SessionRevokedModalComponent {
  private sessionRevokedService = inject(SessionRevokedService);

  showModal$ = this.sessionRevokedService.showModal$;

  onBackToLogin(): void {
    this.sessionRevokedService.navigateToLogin();
  }

  onClose(): void {
    this.sessionRevokedService.closeModal();
    // Also navigate to login when modal is closed
    this.sessionRevokedService.navigateToLogin();
  }
}
